/**
 * ITI AVA - Klaviyo Added to Cart fallback
 *
 * Why this exists:
 * Klaviyo's Shopify Server Pixel is not currently producing the Shopify-branded
 * Added to Cart event for this storefront, while Klaviyo.js / Viewed Product is working.
 * This fallback records the legacy Klaviyo "Added to Cart" metric after a successful
 * Shopify Ajax Cart POST to /cart/add.js. It also opens the Klaviyo 'Save Your Cart'
 * form for anonymous visitors, suppresses it permanently in that browser after a successful
 * email submission, suppresses for logged-in customers and browsers that already submitted the form, and re-sends
 * the cart event after form submission.
 *
 * Remove this file + its include from layout/theme.liquid if the native Shopify-branded
 * Added to Cart event is restored, to avoid duplicate cart events.
 */
(function () {
  if (window.__itiavaKlaviyoAddedToCartFallback) return;
  window.__itiavaKlaviyoAddedToCartFallback = true;

  var nativeFetch = window.fetch;
  if (typeof nativeFetch !== 'function') return;

  window._learnq = window._learnq || [];

  var CART_FORM_ID = 'XYJGj2';
  var CART_EMAIL_CAPTURED_KEY = 'itiava_save_cart_email_captured_v1';
  var pendingPayload = null;

  function hasPositiveShopifyCustomerSignal() {
    // Positive signals only. Never infer signed-in state from account-icon visibility.
    // The previous DOM heuristic could classify signed-out visitors as signed in.
    try {
      if (window.__ITIAVA_CUSTOMER_STATE__ && window.__ITIAVA_CUSTOMER_STATE__.loggedIn === true) return true;

      var candidates = [
        window.meta && window.meta.page && window.meta.page.customerId,
        window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId,
        window.__st && window.__st.cid
      ];

      for (var i = 0; i < candidates.length; i++) {
        var value = candidates[i];
        if (value !== undefined && value !== null && String(value).trim() !== '' && String(value) !== '0') return true;
      }
    } catch (e) {}

    return false;
  }

  function hasCapturedCartEmail() {
    try {
      return window.localStorage.getItem(CART_EMAIL_CAPTURED_KEY) === '1';
    } catch (e) {
      return document.cookie.indexOf(CART_EMAIL_CAPTURED_KEY + '=1') !== -1;
    }
  }

  function markCartEmailCaptured() {
    try {
      window.localStorage.setItem(CART_EMAIL_CAPTURED_KEY, '1');
    } catch (e) {}

    // Cookie fallback for browsers where localStorage is restricted.
    try {
      document.cookie = CART_EMAIL_CAPTURED_KEY + '=1; Max-Age=31536000; Path=/; SameSite=Lax';
    } catch (e) {}
  }

  function openSaveCartForm() {
    // Shopify Liquid is the source of truth for storefront login state.
    // Do not persist login state in localStorage; a shopper can log out later
    // in the same browser and must then be treated as anonymous again.
    if (hasPositiveShopifyCustomerSignal()) return;

    // Once this browser has submitted the Save Your Cart form, never ask again.
    if (hasCapturedCartEmail()) return;

    // Always request the Klaviyo form for anonymous visitors.
    // Klaviyo's own form targeting ("Don't show to existing Klaviyo profiles")
    // remains responsible for suppressing visitors Klaviyo already knows.
    try {
      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        window.klaviyo.openForm(CART_FORM_ID);
        return;
      }
    } catch (e) {}

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', CART_FORM_ID]);
  }

  function money(cents) {
    var value = Number(cents);
    return Number.isFinite(value) ? value / 100 : 0;
  }

  function absoluteUrl(url) {
    if (!url) return window.location.href;
    try {
      return new URL(url, window.location.origin).href;
    } catch (e) {
      return url;
    }
  }

  function normalizeImage(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    return absoluteUrl(url);
  }

  function getAddedItems(addResponse) {
    if (!addResponse || typeof addResponse !== 'object') return [];
    if (Array.isArray(addResponse.items)) return addResponse.items;
    if (addResponse.product_id || addResponse.variant_id || addResponse.id) return [addResponse];
    return [];
  }

  function buildKlaviyoLineItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.map(function (line) {
      var unitPrice = money(
        line.final_price != null ? line.final_price :
        line.discounted_price != null ? line.discounted_price :
        line.price
      );
      var qty = Number(line.quantity) || 1;
      var linePrice = money(
        line.final_line_price != null ? line.final_line_price :
        line.line_price != null ? line.line_price :
        (unitPrice * qty * 100)
      );
      var imageUrl = normalizeImage(
        line.image || (line.featured_image && line.featured_image.url) || ''
      );
      var productUrl = absoluteUrl(line.url || '');

      return {
        id: line.id != null ? String(line.id) : '',
        product_id: line.product_id != null ? String(line.product_id) : '',
        variant_id: line.variant_id != null ? String(line.variant_id) : '',
        title: line.title || line.product_title || '',
        variant_title: line.variant_title || '',
        sku: line.sku || '',
        vendor: line.vendor || '',
        quantity: qty,
        price: unitPrice,
        line_price: linePrice,
        url: productUrl,
        image: imageUrl,
        product: {
          id: line.product_id != null ? String(line.product_id) : '',
          title: line.product_title || line.title || '',
          handle: line.handle || '',
          url: productUrl,
          images: imageUrl ? [{ src: imageUrl }] : []
        }
      };
    });
  }

  function trackAddedItem(item, cart) {
    if (!item) return;

    var unitPrice = money(
      item.final_price != null ? item.final_price :
      item.discounted_price != null ? item.discounted_price :
      item.price
    );
    var quantity = Number(item.quantity) || 1;

    var payload = {
      '$value': unitPrice * quantity,
      '$currency_code': (cart && cart.currency) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
      'Product Name': item.product_title || item.title || '',
      'ProductName': item.product_title || item.title || '',
      'ProductID': item.product_id != null ? String(item.product_id) : '',
      'VariantID': item.variant_id != null ? String(item.variant_id) : (item.id != null ? String(item.id) : ''),
      'Variant Name': item.variant_title || '',
      'Variant SKU': item.sku || '',
      'Product Type': item.product_type || '',
      'Brand': item.vendor || '',
      'ImageURL': normalizeImage(item.image || (item.featured_image && item.featured_image.url) || ''),
      'URL': absoluteUrl(item.url || window.location.pathname),
      'Price': unitPrice,
      'Quantity': quantity,
      'CartTotal': cart ? money(cart.total_price) : undefined,
      'CartItemCount': cart ? Number(cart.item_count) || 0 : undefined,
      'items': buildKlaviyoLineItems(cart),
      'extra': {
        'line_items': buildKlaviyoLineItems(cart),
        'cart_url': absoluteUrl('/cart'),
        'checkout_url': absoluteUrl('/cart'),
        'presentment_currency': (cart && cart.currency) ||
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''
      }
    };

    // Klaviyo's supported legacy onsite event queue. It records only for an
    // identified/cookied profile, which is the same requirement as other onsite events.
    pendingPayload = payload;
    window._learnq.push(['track', 'Added to Cart', payload]);
  }

  function trackFromAddResponse(addResponse) {
    nativeFetch.call(window, '/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        var items = getAddedItems(addResponse);

        // Fallback: if Shopify did not return line-item data, track the newest cart item.
        if (!items.length && cart && Array.isArray(cart.items) && cart.items.length) {
          items = [cart.items[0]];
        }

        items.forEach(function (item) {
          trackAddedItem(item, cart);
        });

        // Ask anonymous/new visitors for an email after a successful cart add.
        // Klaviyo targeting is configured to suppress this form for existing profiles.
        openSaveCartForm();
      })
      .catch(function () {
        // Do not break cart UX if analytics fails.
      });
  }


  // When a new visitor submits the Save Your Cart form, Klaviyo has now
  // identified the browser. Re-send the latest cart event so the new profile
  // receives the Added to Cart metric and can enter the reminder flow.
  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    if (e.detail.type !== 'submit' || e.detail.formId !== CART_FORM_ID) return;

    // Remember that this browser has already provided an email, so the
    // Save Your Cart popup will not be shown again on future cart adds.
    markCartEmailCaptured();
    if (!pendingPayload) return;

    var payloadToSend = pendingPayload;
    pendingPayload = null;

    window.setTimeout(function () {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added to Cart', payloadToSend]);
    }, 1200);
  });


  window.__itiavaCartPopupDebug = function () {
    return {
      shopifyCustomerSignal: hasPositiveShopifyCustomerSignal(),
      capturedEmailInBrowser: hasCapturedCartEmail(),
      formId: CART_FORM_ID
    };
  };

  // Test helper only: clears the one-time form-submission flag in this browser.
  window.__itiavaCartPopupResetForTesting = function () {
    try { window.localStorage.removeItem(CART_EMAIL_CAPTURED_KEY); } catch (e) {}
    try { document.cookie = CART_EMAIL_CAPTURED_KEY + '=; Max-Age=0; Path=/; SameSite=Lax'; } catch (e) {}
    return true;
  };

  window.fetch = function () {
    var args = arguments;
    var requestUrl = '';

    try {
      requestUrl = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    } catch (e) {}

    var promise = nativeFetch.apply(this, args);

    // Only observe Shopify Ajax add-to-cart requests. Do not alter the response.
    try {
      var parsed = new URL(requestUrl, window.location.origin);
      if (parsed.origin === window.location.origin && /\/cart\/add(?:\.js)?$/.test(parsed.pathname)) {
        promise.then(function (response) {
          if (!response || !response.ok) return;
          response.clone().json().then(trackFromAddResponse).catch(function () {
            trackFromAddResponse(null);
          });
        }).catch(function () {});
      }
    } catch (e) {}

    return promise;
  };
})();
